import { createBrowserRouter } from 'react-router-dom'
import { AppLayout } from '@/components/layout/AppLayout'
import { PortalLayout } from '@/components/layout/PortalLayout'
import { RouteErrorBoundary } from '@/components/feedback/RouteErrorBoundary'

export const router = createBrowserRouter([
  {
    path: '/', Component: AppLayout, ErrorBoundary: RouteErrorBoundary,
    children: [
      { index: true, lazy: () => import('@/pages/home/route') },
      {
        path: 'docs', lazy: () => import('@/pages/docs/layoutRoute'),
        children: [
          { index: true, lazy: () => import('@/pages/docs/homeRoute') },
          { path: 'api/:group', lazy: () => import('@/pages/docs/apiGroupRoute') },
          { path: 'api/:group/:operation', lazy: () => import('@/pages/docs/endpointRoute') },
          { path: '*', lazy: () => import('@/pages/docs/guideRoute') },
        ],
      },
      { path: 'login', lazy: () => import('@/pages/auth/loginRoute') },
      { path: 'register', lazy: () => import('@/pages/auth/registerRoute') },
      { path: 'forgot-password', lazy: () => import('@/pages/auth/forgotRoute') },
      { path: 'reset-password', lazy: () => import('@/pages/auth/resetRoute') },
      { path: 'invitation', lazy: () => import('@/pages/auth/invitationRoute') },
      { path: 'track', lazy: () => import('@/pages/tracking/route') },
      { path: 'track/:trackingCode', lazy: () => import('@/pages/tracking/route') },
    ],
  },
  {
    path: '/app', Component: PortalLayout, ErrorBoundary: RouteErrorBoundary,
    children: [
      { index: true, lazy: () => import('@/pages/dashboard/route') },
      { path: 'deliveries', lazy: () => import('@/pages/orders/route') },
      { path: 'deliveries/new', lazy: () => import('@/pages/orders/newRoute') },
      { path: 'deliveries/:orderId', lazy: () => import('@/pages/orders/detailRoute') },
      { path: 'reports', lazy: () => import('@/pages/reports/route') },
      { path: 'wallet', lazy: () => import('@/pages/finance/walletRoute') },
      { path: 'transactions', lazy: () => import('@/pages/finance/transactionsRoute') },
      { path: 'invoices', lazy: () => import('@/pages/finance/invoicesRoute') },
      { path: 'ledger', lazy: () => import('@/pages/finance/ledgerRoute') },
      { path: 'users', lazy: () => import('@/pages/management/usersRoute') },
      { path: 'teams', lazy: () => import('@/pages/management/teamsRoute') },
      { path: 'api-keys', lazy: () => import('@/pages/developer/apiKeysRoute') },
      { path: 'webhooks', lazy: () => import('@/pages/developer/webhooksRoute') },
      { path: 'settings', lazy: () => import('@/pages/settings/route') },
      { path: 'audit', lazy: () => import('@/pages/management/auditRoute') },
      { path: '*', lazy: () => import('@/pages/not-found/route') },
    ],
  },
  { path: '*', lazy: () => import('@/pages/not-found/route') },
])
